import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

export const ViewLostState = {
	url: '/lost/:customerToken/:serviceProviderId/:consultationId',
	title: 'View Lost Consultation',
	params: {customerToken: null, serviceProviderId: null, consultationId: null},
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<view-lost-v2></view-lost-v2>'
				: '<lost-page></lost-page>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return (
			RoutesSvc.getPresentationFlags({trans: $transition$})
				// a failed lookup imports the production page; the providerFlags resolve below
				// reports the failure, so it is not swallowed here
				.catch(() => ({}))
				.then(flags =>
					flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
						? import(
								/* webpackChunkName: "viewLostV2Mod" */
								'@Containers/view-lost-page/view-lost-v2.cmp.js'
							)
						: import(
								/* webpackChunkName: "viewLostPageMod" */
								'@Containers/view-lost-page/view-lost-page.cmp.js'
							)
				)
				.then(res => $ocLazyLoad.load({name: res.default}))
				.catch(err => $log.error(err))
		);
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPublic({status: 'lost', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) => RoutesSvc.getPresentationFlags({trans}),
		},
	],
};
